module.exports = __webpack_public_path__ + "static/media/skila-bg_img-02-1-pod_600px_width-0_1-@1x.1626be5e.png";